import { array } from "prop-types";
import "toastr/build/toastr.min.css";
import { toast } from "react-toastify";
import { USER_WORK_SHIFT } from "../config/apiEndPoint";
import { GET, POST, PUT } from "config/api.config";

export const submitUserWorkShiftFilterData = async (data = array()) => {
  try {
    const response = await POST(USER_WORK_SHIFT.SUBMIT_FILTER_DATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const fetchUserWorkShiftTableAndFilterSchema = async (data = array()) => {
  try {
    const response = await GET(USER_WORK_SHIFT.GET_WORK_SHIFT_SCHEMA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const addUserWorkShift = async (data = array()) => {
  try {
    const response = await POST(USER_WORK_SHIFT.GET_WORK_SHIFT_LIST, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const updateUserWorkShift = async (id, data = array()) => {
  try {
    const url = `${USER_WORK_SHIFT.GET_WORK_SHIFT_LIST}/${id}`;
    const response = await PUT(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};
